import _ from "lodash";

export default [
  'ResourceService',
  class CampaignService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/campaigns';
    }

    initializeSession (publicID, slug, query) {
      if (!publicID || !slug) {
        return this._resourceService.errorPromise('campaign:initializeSession: missing parameters');
      }

      let q = _.clone(query);
      _.extend(q, { referrer: document.referrer });

      return this._resourceService.get(`${this._API_BASE}/${publicID}/${slug}/initialize`, {
        params: q,
        paramSerializer: '$httpParamSerializerJQLike'
      });
    }

    getById(id) {
      if (!id) {
        return this._resourceService.errorPromise('campaign:getById: missing parameters');
      }
      return this._resourceService.get(`${this._API_BASE}/${id}`);
      //.then( cache in this._campaignDetails ); ?
    }

    getBySlug(publicID, slug) {
      if (!publicID || !slug) {
        return this._resourceService.errorPromise('campaign:getBySlug: missing parameters');
      }

      return this._resourceService.get(`/users/${publicID}/campaigns/${slug}/customer`);
    }

    getFeatured(limit) {
      let query;
      if (typeof limit === 'number') {
        query = `?limit=${limit}`;
      }

      return this._resourceService.get(`${this._API_BASE}/featured${query}`);
    }

    validateCoupon(publicID, slug, coupon) {
      if (!publicID || !slug || !coupon) {
        return this._resourceService.errorPromise('campaign:validateCoupon: missing parameters');
      }

      return this._resourceService.get(`/users/${publicID}/campaigns/${slug}/validate-coupon?discount_code=${encodeURIComponent(coupon)}`);
    }

    getTracking(publicID, slug) {
      if (!publicID || !slug) {
        return this._resourceService.errorPromise('campaign:getTracking: missing parameters');
      }

      return this._resourceService.get(`/users/${publicID}/campaigns/${slug}/tracking`);
    }

    getUpsells(id, previous, country) {
      if (!id) {
        return this._resourceService.errorPromise('campaign:getUpsells: missing parameter');
      }

      let query = '?';
      if (Array.isArray(previous) && previous.length > 0) {
        let csv = previous.join(',');
        query += `previously_viewed_upsells=${csv}`;
      }

      if (typeof country == 'string') {
        if (query.length > 1) query += '&';
        query += `country=${country}`;
      }

      return this._resourceService.get(`${this._API_BASE}/${id}/upsells${query}`);
    }

    getTrending(limit, type) {
      let query;
      limit || (limit = 4);
      type || (type = null);

      return this._resourceService.get(`${this._API_BASE}/trending`, {
        params: {
          limit: limit,
          pcat: type
        },
        paramSerializer: '$httpParamSerializerJQLike'
      });
    }

    toggleCampaignLockFromMarketplace(id, lock, unhide) {
      if (!id || typeof lock === 'undefined' || typeof unhide === 'undefined') {
        return this._resourceService.errorPromise('campaign:toggleCampaignLockFromMarketplace: missing parameters');
      }
      return this._resourceService.post(`${this._API_BASE}/${id}/marketplace/lock`, {
        lock: lock ? 1 : 0,
        unhide: unhide ? 1 : 0
      });
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/campaign-service.js